import { render, staticRenderFns } from "./prueba2.vue?vue&type=template&id=6943590e&scoped=true"
import script from "./prueba2.vue?vue&type=script&lang=js"
export * from "./prueba2.vue?vue&type=script&lang=js"
import style0 from "./prueba2.vue?vue&type=style&index=0&id=6943590e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6943590e",
  null
  
)

export default component.exports